import React from 'react';
import { isMobile } from 'react-device-detect';
import { formatDatePTBR } from '../../core/utils/timeConvert';
import { normalizeDecimalSeparator } from '../../screens/ModalBudget/utils/functions';

export const OsPrint = React.forwardRef((props, ref) => {
  const { printWithValues } = props;

  function abbreviateName(name) {
    const words = name.split(' ');

    if (words.length > 3) {
      return words
        .map((word, index) => {
          if (index === 0 || index === 1 || index === words.length - 1) {
            return word;
          }
          return word.charAt(0) + '.';
        })
        .join(' ');
    }

    return name;
  }

  const serviceArray = (props.bodyshopService || []).sort((a, b) => a?.title?.localeCompare(b.title));
  const aeServiceArray = (props.aeService || []).sort((a, b) => a?.title?.localeCompare(b.title));
  const partsArray = (props.parts || []).sort((a, b) => a?.name?.localeCompare(b.name));

  const clientFound = props?.client.find(
    (client) =>
      client?.value === props?.values?.client ||
      client?.value === props?.values?.client?.value
  );

  const consultat = props.consultantState?.filter(
    (item) => item.id === props.values.id_consultant
  )[0];
  const financialCoresponsible = props?.client.find(
    (client) =>
      client?.value === props?.values?.financial_coresponsible ||
      client?.value === props?.values?.financial_coresponsible?.value
  );

  // Renderizar linhas de serviços
  const renderServiceRows = () => {
    const allServices = [...serviceArray, ...aeServiceArray];
    return allServices.map((item, index) => {
      const isAesthetic = aeServiceArray.includes(item);
      return (
        <tr key={`service-${index}`}>
          <td>
            <div>
              <span>{item?.title}</span>
              {isAesthetic &&
                Array.isArray(item.services) &&
                item.services.length > 0 && (
                  <div style={{ marginTop: '5px' }}>
                    {item.services.map((service, sIndex) => (
                      <span
                        key={sIndex}
                        style={{
                          display: 'block',
                          color: 'gray',
                          fontSize: '12px',
                        }}
                      >
                        {service.title}
                      </span>
                    ))}
                  </div>
                )}
            </div>
          </td>
          <td>{isAesthetic ? item?.quantity || 1 : item?.time}</td>
          {printWithValues ? (
            <>
              <td className="with-values">
                R$
                {item?.unitaryValue === null || item.unitaryValue === 'undefined'
                  ? '0.00'
                  : parseFloat(item?.unitaryValue).toFixed(2)}
              </td>
              <td className="with-values">
                R$
                {item?.value !== 'NaN' ? parseFloat(item?.value).toFixed(2) : '0'}
              </td>
            </>
          ) : (
            <td className="without-values">{item?.observation || ''}</td>
          )}
        </tr>
      );
    });
  };

  // Renderizar linhas de peças
  const renderPartsRows = () => {
    return partsArray.map((item, index) => (
      <tr key={`part-${index}`}>
        <td>{item?.id}</td>
        <td>{item?.name}</td>
        <td>{item?.quantity ? item.quantity : '0'}</td>
        {printWithValues ? (
          <>
            <td className="with-values">
              R$
              {item?.value && item?.quantity
                ? (parseFloat(item?.value) / item?.quantity).toFixed(2)
                : item?.unitaryValue
                ? item.unitaryValue
                : '0.00'}
            </td>
            <td className="with-values">
              R${item?.value ? parseFloat(item?.value).toFixed(2) : '0.00'}
            </td>
          </>
        ) : (
          <td className="without-values">{item?.observation || ''}</td>
        )}
      </tr>
    ));
  };

  return (
    <div
      className={`os-print-container${isMobile ? ' mobile' : ''}${
        !printWithValues ? ' no-values' : ''
      }`}
      id="my-node"
      ref={ref}
    >
      <div id="print-padding-mobile" className="print-padding-mobile">
        <div className="os-print-header">
          <div></div>
          <text className="header-title">ORDEM DE SERVIÇO</text>
          <text className="header-code">N° {props.values.code}</text>
        </div>

        <div className="company-info-section">
          {(props.logoBase64 || props.company.logo) && (
            <img
              className="print-logo-os"
              src={
                props.logoBase64 ||
                `${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${props.company.logo}`
              }
              alt="Logo da empresa"
              loading="eager"
              style={{
                width: '125px',
                maxWidth: '125px',
                maxHeight: '110px',
                objectFit: 'cover',
                padding: '5px',
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          )}
          <div className="company-details">
            <div className="company-main-info">
              <div className="company-text">
                <text>{props.company.name}</text>
              </div>
              <div className="company-text">
                <text>{props.company.cnpj}</text>
              </div>
              <div className="company-text">
                <text>
                  {props.company.street}, N°{props?.company?.number},{' '}
                  {props.company.neighborhood}, {props.company.city},{' '}
                  {props.company.state}
                  {props.company.complement ? ',' : ''}{' '}
                  {props.company.complement}
                  <br />
                  CEP: {props.company.cep}
                </text>
              </div>
              <div className="company-text">
                <text>Fone: {props.company.telephone}</text>
                <text>Whastapp: {props.company.cellphone}</text>
              </div>
            </div>

            <div className="company-meta-info">
              <text>
                Data abertura: {formatDatePTBR(props.values?.entry_date)}{' '}
                {props.values?.entry_hour}
              </text>
              <text className="delivery-date">
                Previsão entrega: {formatDatePTBR(props.values?.delivery_date)}{' '}
                {props.values?.delivery_hour}
              </text>
              <text>Consultor: {consultat?.label}</text>
              <text>
                Tipo de OS: <strong>{props?.values?.os_type?.label}</strong>
              </text>
            </div>
          </div>
        </div>
        {/* Area cliente, cpf/cnpj/ telefone */}

        <div className="client-section">
          <div className="client-info">
            <text className="client-name">
              Nome Cliente:{' '}
              <strong className="client-name-value">
                {clientFound?.label ? abbreviateName(clientFound.label) : '---'}
              </strong>
            </text>
            <text className="financial-responsible">
              Responsável Financeiro:{' '}
              <strong className="financial-responsible-value">
                {financialCoresponsible?.label
                  ? abbreviateName(financialCoresponsible.label)
                  : '---'}
              </strong>
            </text>
          </div>
        </div>

        <div className="vehicle-section">
          <div className="vehicle-data-column">
            <div className="vehicle-header">DADOS VEÍCULO</div>
            <div className="vehicle-content">
              <div className="vehicle-info-row">
                <text>Marca/Modelo:</text>
                <text className="vehicle-value">
                  {props.values.Vehicle?.model || '---'}
                </text>
              </div>
              <div className="vehicle-info-row">
                <text>Kilometragem:</text>
                <text className="vehicle-value">
                  {props.values.mileage || '---'} km
                </text>
              </div>
            </div>
          </div>

          <div className="vehicle-details-grid">
            <div className="vehicle-detail-row">
              <text>Placa:</text>
              <text className="vehicle-detail-value">
                {props.values.Vehicle?.plate || '---'}
              </text>
            </div>
            <div className="vehicle-detail-row">
              <text>Motor:</text>
              <text className="vehicle-detail-value">
                {props.values.Vehicle?.engine || '---'}
              </text>
            </div>
            <div className="vehicle-detail-row">
              <text>Cor:</text>
              <text className="vehicle-detail-value">
                {props.values.Vehicle?.color || '---'}
              </text>
            </div>
            <div className="vehicle-detail-row">
              <text>Ano/Modelo:</text>
              <text className="vehicle-detail-value">
                {props.values.Vehicle?.year || '---'}/
                {props.values.Vehicle?.yearmodel || '---'}
              </text>
            </div>
            <div className="vehicle-detail-row">
              <text>Combustível:</text>
              <text className="vehicle-detail-value">
                {props.values.Vehicle?.fuel || '---'}
              </text>
            </div>
            <div className="vehicle-detail-row chassi">
              <text>Chassi:</text>
              <text className="vehicle-detail-value">
                {props.values.Vehicle?.chassi || '---'}
              </text>
            </div>
          </div>
        </div>

        {/* Area de serviços */}

        <div className="section-services" style={{ paddingBottom: '16px' }}>
          <div className="section-header">
            <text className="section-title">RELAÇÃO DOS SERVIÇOS</text>
          </div>
          <table id="serviceTable">
            <thead>
              <tr>
                <th>Descrição</th>
                <th style={{ width: '135px' }}>Qtdade / Horas</th>
                <th className="with-values" style={{ width: '100px' }}>
                  Valor Unit.
                </th>
                <th className="with-values" style={{ width: '100px' }}>
                  Valor Total
                </th>
                <th className="without-values" style={{ width: '200px' }}>
                  Observação
                </th>
              </tr>
            </thead>
            <tbody>{renderServiceRows()}</tbody>
          </table>
        </div>
        {/* Area de peças */}
        <div className="section-parts" style={{ paddingBottom: '16px' }}>
          <div className="section-header parts-header">
            <text className="section-title">RELAÇÃO DOS PRODUTOS</text>
          </div>
          <table id="partsTable">
            <thead>
              <tr>
                <th style={{ width: '100px' }}>Cód Peça</th>
                <th style={{}}>Descrição</th>
                <th style={{ width: '70px' }}>Qtdade</th>
                <th className="with-values" style={{ width: '100px' }}>
                  Valor Unit.
                </th>
                <th className="with-values" style={{ width: '100px' }}>
                  Valor Total
                </th>
                <th className="without-values" style={{ width: '200px' }}>
                  Observação
                </th>
              </tr>
            </thead>
            <tbody>{renderPartsRows()}</tbody>
          </table>
        </div>
        {/* Parte final do documento */}

        <div
          className={`section-totals ${!printWithValues ? 'no-values' : ''}`}
        >
          <div className="totals-container with-values">
            {/* Coluna Serviços */}
            <div className="total-column">
              <div className="total-main">
                TOTAL SERVIÇOS:{' '}
                {props?.totalServices?.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </div>
              {(() => {
                const bodyshopDiscount =
                  parseFloat(
                    normalizeDecimalSeparator(props?.values?.bodyshop_discount)
                  ) || 0;
                const aestheticsDiscount =
                  parseFloat(
                    normalizeDecimalSeparator(
                      props?.values?.aesthetics_discount
                    )
                  ) || 0;
                const totalServiceDiscount =
                  bodyshopDiscount + aestheticsDiscount;

                if (totalServiceDiscount > 0) {
                  const totalServices = props?.totalServices || 0;
                  const totalPercentage =
                    totalServices > 0
                      ? ((totalServiceDiscount / totalServices) * 100).toFixed(
                          1
                        )
                      : 0;
                  return (
                    <>
                      <div className="total-discount">
                        DESCONTO %: {totalPercentage}%
                      </div>
                      <div className="total-discount">
                        VALOR DESCONTO:{' '}
                        {totalServiceDiscount.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </div>
                      <div className="total-final">
                        {(
                          (props?.totalServices || 0) - totalServiceDiscount
                        ).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </div>
                    </>
                  );
                }
                return null;
              })()}
            </div>

            {/* Coluna Peças */}
            <div className="total-column">
              <div className="total-main">
                TOTAL PRODUTOS:{' '}
                {props?.totalParts?.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </div>
              {(() => {
                const partsDiscount =
                  parseFloat(
                    normalizeDecimalSeparator(props?.values?.parts_discount)
                  ) || 0;
                const partsPercentage =
                  parseFloat(props?.values?.parts_percentage_discount) || 0;

                if (partsDiscount > 0) {
                  return (
                    <>
                      <div className="total-discount">
                        DESCONTO %: {partsPercentage}%
                      </div>
                      <div className="total-discount">
                        VALOR DESCONTO:{' '}
                        {partsDiscount.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </div>
                      <div className="total-final">
                        {(
                          (props?.totalParts || 0) - partsDiscount
                        ).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </div>
                    </>
                  );
                }
                return null;
              })()}
            </div>

            {/* Coluna Total */}
            <div className="total-column">
              <div className="total-main">
                TOTAL GERAL:{' '}
                {props?.totalSum?.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </div>
              {(() => {
                const totalDiscount =
                  (parseFloat(
                    normalizeDecimalSeparator(props?.values?.bodyshop_discount)
                  ) || 0) +
                  (parseFloat(
                    normalizeDecimalSeparator(
                      props?.values?.aesthetics_discount
                    )
                  ) || 0) +
                  (parseFloat(
                    normalizeDecimalSeparator(props?.values?.parts_discount)
                  ) || 0);

                if (totalDiscount > 0) {
                  return (
                    <>
                      <div className="total-discount">
                        DESCONTOS:{' '}
                        {totalDiscount.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </div>
                      <div className="total-final">
                        TOTAL COM DESCONTO:{' '}
                        {(
                          (props?.totalSum || 0) - totalDiscount
                        ).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </div>
                    </>
                  );
                }
                return null;
              })()}
            </div>
          </div>
          <div>
            <div className="section-header parts-header">
              <text className="section-title">RELATO CLIENTE</text>
            </div>
            <div className="report-section">
              <div className="report-content">
                <div className="report-text">
                  {props.values.customer_report}
                </div>
              </div>
            </div>
          </div>
          <div className="observations-section">
            <div className="section-header parts-header">
              <text className="section-title">OBSERVAÇÕES</text>
            </div>
            <div className="report-section">
              <div className="report-content">
                <div className="report-text">{props.observation}</div>
              </div>
            </div>
          </div>

          {printWithValues && (
            <div className="signature-section">
              <text className="signature-line">VISTO DO CLIENTE</text>
              <text className="signature-line">VISTO DA OFICINA</text>
            </div>
          )}

          {!printWithValues && (
            <div className="diverse-notes-container">
              <text>ANOTAÇÕES DIVERSAS</text>
              <ol>
                {Array.from({ length: 15 }).map((_, index) => (
                  <li>{index + 1}</li>
                ))}
              </ol>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
